/* eslint-disable no-new */

// eslint-disable-next-line simple-import-sort/imports
import 'root/apps/shared_modules/Analytics';
import 'root/apps/helpers/react-component-history';

import 'root/datadog/datadogRum';
import { datadogLogsInit } from 'root/datadog/datadogLogs';

import 'Autocomplete/Brands';
import 'Autocomplete/Vendors';
import 'Autocomplete/Tags';
import 'Autocomplete/Serials';
import 'Autocomplete/Languages';
import 'Autocomplete/CustomerTypes';
import 'Address/.';
import 'BulkDeleteButton/.';
import 'GiftReceiptModal/.';
import 'Transfer/.';
import 'PasswordValidator/.';
import 'root/lib/embeds/localize';
import 'root/calendar/CalendarLocale';
import 'root/system';
import 'root/merchantos/activity';
import 'root/merchantos/server_call';
import 'root/merchantos/register';
import 'root/merchantos/register/terminal_payment';
import 'root/merchantos/product_images/product_image';
import 'SerializedRefund';
import 'Tooltip/ListingColumnTooltip';
import 'Tooltip/NetworkHealthMonitorTooltip';
import 'Tooltip/ReorderPointNeed';
import 'Tooltip/PurchaseOrderShippingCost';
import 'Tooltip/CostOrderTotal';
import 'Partition/PartitionCollapseToggle/PartitionCollapseToggle';
import 'PurchaseOrder/AddSerialButton';
import 'PurchaseOrder/AnalyticsDemandPO/index';
import 'PurchaseOrder/AnalyticsLoader';
import 'PurchaseOrder/AnalyticsLoader/AnalyticsColumnHeaders';
import 'PurchaseOrder/LandedCostControl';
import 'PurchaseOrder/PrintDropDown';
import 'PurchaseOrder/ShipmentHistory/tabs';
import 'PurchaseOrder/NuorderOrdering';
import 'PurchaseOrder/SendToNuorderModal';
import 'PurchaseOrder/ReceivedInventoryAlert';
import 'ItemArchiveModal/index';
import 'Inventory/ReorderPoints';
import 'Inventory/ShowDemandForecast';
import 'Inventory/ServiceDefaults/index';
import 'InventoryCount/index';
import 'InventoryCountReconcile/index';
import 'InventoryCountScanQueue/index';
import 'TaxClassForm/index';
import 'WorkorderCompleteAllModal/index';
import 'pages/components/RichTextEditor';
import 'pages/gui-defs/EcomRadManagement';
import 'pages/gui-defs/DeleteAccount';
import 'pages/gui-defs/CustomAlert';
import 'pages/gui-defs/ConsentConfirmation';
import 'pages/gui-defs/CreateVendorReturn';
import 'pages/gui-defs/EmployeeShops';
import 'pages/components/Sidebar';
import 'pages/gui-defs/DiscountRules';
import 'root/apps/pages/views/inventory/B2B/B2BItemsListing';
import 'pages/gui-defs/MigrationTool';
import 'payments/PaymentsSetupBanner';
import 'root/apps/QuoteMachineIntegration/components/ACHPayments/ACHPaymentsProcessingTooltip';
import 'root/apps/payments/PaymentLinkBanner';
import 'root/apps/payments/components/initPreauthButton';
import 'root/apps/Hub/Receipt';
import 'root/apps/components/Notifications/TabNotification';
import 'root/apps/components/VoidSale';
import 'root/apps/components/Topbar/TopbarAlertMessage';
import 'root/apps/item_import/import_type_select/ImportTypeSelect';
import 'root/apps/matrix/MatrixAttributes';
import 'root/apps/publish_to_ecom/PublishToEcomButtons';
import 'root/apps/item_chart';
import 'root/apps/CapitalBanner';
import 'root/apps/pages/views/reports/CustomerData/BannerContent';
import 'root/apps/CreditAccountStatement';
import 'root/apps/DeploymentInfoModal';
import 'root/apps/RegisterCFDCustomer';
import 'root/apps/RegisterCustomerPreauths';
import 'root/apps/RegisterRules';
import 'root/apps/importSass';
import 'root/apps/pikaday/pikaday';
import 'root/apps/MakeTaxDigitalUK';
import 'root/apps/MultiLocationSaleModal';
import 'root/apps/NuorderBanner';
import 'root/apps/RAD/ImpersonationButton';
import 'root/apps/SerializedRefund/SerializedRefundSelectedLines';
import 'root/apps/SerializedRefund/SerializedRefundButton';
import 'root/apps/AutoDismissiblePillBadge';
import 'root/apps/TileNotificationCount';
import 'root/apps/pages/views/settings/MAS/SubscriptionSetup';
import 'root/apps/eComValidation';
import 'root/apps/ModuleCompareUI';
import 'payments/PaymentDepositModal/PaymentLinkDepositTile';
import 'root/apps/components/RemoveCustomerButton/RemoveCustomerButton';
import 'root/apps/matrix/components/ListingTopAlert';
import 'root/apps/WorkOrderCalendarFeed';
import { ENVIRONMENTS, getEnvFromHostname } from 'pages/utils/getEnvFromHostname';
import { initHub } from 'pages/views/devices/utils/client';
import Churnzero from 'root/apps/churnZero/ChurnZero';
import HelpModal from 'root/apps/help_modal/HelpModal';
import Intercom from 'root/apps/intercom/Intercom';
import ItemImportHelp from 'root/apps/item_import/ItemImportHelp';
import PublishToEcom from 'root/apps/publish_to_ecom/PublishToEcom';
import Qualtrics from 'root/apps/qualtrics/Qualtrics';
import CancelSubscription from 'root/apps/qualtrics_churn_survey/CancelSubscription';
import VoidSale from 'root/apps/void_sale_modal/VoidSale';
import 'root/apps/QuoteMachineIntegration/components/CreditAccountBalance/CreditAccountBalance';
import 'root/apps/QuoteMachineIntegration/components/PaymentTile';
import 'root/apps/QuoteMachineIntegration/components/InvoiceReferenceBanner/InvoiceReferenceBanner';
import 'root/apps/QuoteMachineIntegration/components/CustomerCreditAccountDetails/CustomerCreditAccountDetailsHeading';
import 'root/apps/QuoteMachineIntegration/components/CustomerCreditAccountDetails/CreateCreditAccountButton';
import 'root/apps/QuoteMachineIntegration/components/CustomerCreditAccountDetails/CustomerCreditAccountDetails';
import 'root/apps/QuoteMachineIntegration/components/CustomerInvoicesList/CustomerInvoicesList';
import 'root/apps/QuoteMachineIntegration/components/AutomatedARManagementTool';
import 'root/apps/CreditAndDepositRefund';
import 'root/apps/PreauthExpiringBadge';
import 'root/apps/PreAuthPromoBanner';
import 'root/apps/Workorder';
import 'root/apps/SavedCards';
import 'root/apps/SavedCards/OptInCheckBox';
import 'root/apps/SavedCards/SavedCardsHeader';
import 'root/apps/pages/views/options/CashRoundingAlert';
import 'root/apps/pages/views/options/CashRoundingToggle';
import 'root/apps/pages/views/options/CashRoundingDenominationExamples';
import 'root/apps/QuoteMachineIntegration/components/PaymentRequest/Button/Button';
import 'root/apps/QuoteMachineIntegration/components/PaymentRequest/TotalsSection/TotalsSection';

/**
 * React router based applications
 *
 * These are applications that use React Router to manage their routing.
 * These are rendered on data-react-root="ReactPage" element.
 */
import 'pages/index';

$(async () => {
  await import('root/apps/components/Topbar');

  datadogLogsInit();

  initHub();
  if (getEnvFromHostname() !== ENVIRONMENTS.DEVELOPMENT) {
    Qualtrics.init();

    if (window.lsCloud.Modules.hasModule('churnzero')) {
      Churnzero.init();
    }

    if (window.lsCloud.Modules.hasModule('intercom.support')) {
      Intercom.init();
    }
  }

  new HelpModal();
  new ItemImportHelp();
  new CancelSubscription();
  new VoidSale();
  new PublishToEcom();

  // Trigger a changeState event to mount components on the register.
  if (
    !window.history_changed &&
    (window.location.pathname === '/register.php' ||
      window.location.pathname === '/change_password.php')
  ) {
    window.history.changeState();
  }
});
